import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { useLoggedIn, useAdminUser, usePasswordResetToken } from '../context/contextHooks';
import Login from "../login/Login";
import ManageUsers from "../users/ManageUsers";
import BalanceLookup from "../lookup/BalanceLookup";
import MiscFees from '../miscFees/MiscFees';
import UnappliedPayments from "../unapplied/UnappliedPayments";
import ProcessReset from "../login/ProcessReset";
import DocLink from './DocLink';
import TandC from "./TandC";
import Legal from "./Legal";
import ContactUs from "./ContactUs";
import ManageLogging from "../callLogging/ManageLogging";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export function MainRouter() {
    const [loggedIn,] = useLoggedIn()
    const adminUser = useAdminUser()
    const [passwordResetToken, setPasswordResetToken] = usePasswordResetToken()
    let prToken = passwordResetToken
    let query = useQuery();

    if (!loggedIn) {
        if (!passwordResetToken) {
            prToken = query.get('prt');
            if (prToken) {
                setPasswordResetToken(prToken)
            }
        }
    }

    return (
        <Routes>
            <Route path="/" element={prToken ? <ProcessReset /> : <Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/lookup" element={<BalanceLookup />} />
            <Route path='/users' element={adminUser ? <ManageUsers /> : <Login /> } />
            <Route path='/miscFees' element={<MiscFees />} />
            <Route path='/unapplied' element={<UnappliedPayments />} />
            <Route path='/logging' element={<ManageLogging />} />
            <Route path='/terms' element={<DocLink component={<TandC />} />} />
            <Route path='/legal' element={<DocLink component={<Legal />} />} />
            <Route path='/contact' element={<DocLink component={<ContactUs />} />} />

            {/* default redirect to home page */}
            {/*<Navigate from="*" to="/search" />*/}
        </Routes>
    );
}


export default MainRouter;